'use strict';

const SOURCES = new Set([
    'birthchart_pdf', 'birthchart_houses', 'birthchart_aspects', 'birthchart_ai_chat',
    'cancel_page_subscribe', 'cancel_page_try_again', 'compatibility', 'compatibility_history',
    'compatibility_premium', 'direct', 'horoscope', 'horoscope_ai_chat', 'influencias',
    'navbar', 'navbar_mobile', 'premium_required', 'settings_subscription',
    'settings_upgrade', 'subscription_page',
]);
const STAGES = new Set(['offer_viewed', 'cta_clicked', 'checkout_redirected', 'checkout_client_failed']);

function purchaseSource(value) {
    return SOURCES.has(value) ? value : 'direct';
}

function recordPurchaseStage(windowObject, source, stage) {
    if (!STAGES.has(stage) || typeof windowObject?.fetch !== 'function') return;
    try {
        Promise.resolve(windowObject.fetch('/api/telemetry/purchase-prompt', {
            method: 'POST',
            credentials: 'same-origin',
            referrerPolicy: 'no-referrer',
            keepalive: true,
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({source: purchaseSource(source), stage}),
        })).catch(() => {});
    } catch (_) { /* Measurement must never interrupt purchase or navigation. */ }
}

module.exports = {purchaseSource, recordPurchaseStage};
